import { render } from "./system_settings.html?vue&type=template&id=bc85b6ea&external"
import script from "./system_settings.js?vue&type=script&lang=js&external"
export * from "./system_settings.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__